module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Precipitation/Kanagawa_Precipitation_MRI_RCP45_Mid.png";